import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import * as moment from "moment";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { RightShipInspectionsService } from "../../../../../../services/rightship-inspections/rightship-inspections.service";
import { GoogleAnalyticsService } from "@rightship-tech/common-ui/services/analytics/google-analytics.service";
import { InspectorAssignmentFormProposalStatusEnum } from "../../../../../../models/rightship-inspections/rightship-inspections.models";
@transient()
@autoinject
export class ResendBookingRequestDialog {

    public assignment: any;
    public loading: boolean = false;
    onProceed: () => void;
    onCancel: () => void;

    constructor(private dialogClientService: DialogClientService, private googleAnalyticsService: GoogleAnalyticsService,
        private inspectionService : RightShipInspectionsService,
        private notificationClientService: NotificationClientService) {
    }

    activate(model: { assignment:any, onProceed: () => Promise<void>, onCancel: () => void })
    {
        this.assignment = model.assignment;
        this.onProceed = model.onProceed;
        this.onCancel = model.onCancel;
    }

    close() {
        this.dialogClientService.hide(true);
    }

    async proceed()
    {
        try {
            //trigger loading
            this.loading = true;

            //Implement resend booking request
            await this.inspectionService.resendBookingRequest({ bookingRequestId : this.assignment.id });
            
            //Send GA event
            if(this.assignment.proposalStatusId == InspectorAssignmentFormProposalStatusEnum.Pending){
                this.googleAnalyticsService.sendCustomGA4Event("rs_insp_resend_booking_request");
            }

            //terminate loading
            this.loading = false;
            if(this.onProceed)
                this.onProceed();

            this.close();
            this.notificationClientService.show("Success", "Resend Booking Request Successfully", NotificationType.Success);
        } catch (e) {            
            //terminate loading
            this.loading = false; 
            //Add error message
            this.notificationClientService.show("Error", "Resend Booking Request Failed", NotificationType.Error);
        }
    }

    //Get date string
    getDateString(date: Date | string) {
        const dateFormatted = moment(date).format('DD MMM YYYY HH:mm');

        //check if moment returns invalid date
        if(dateFormatted === 'Invalid date') {
            return null;
        }
        return dateFormatted;
    }    

    cancel()
    {
        if(this.onCancel)
            this.onCancel();

        this.close();
    }
}